// @ts-nocheck
import { getValue } from './getTheme';
import { createParser } from './createParser';
import css from './css';

export interface VariantArgs<TStyle = object, K extends string = string, TPropName = string> {
  /** Component prop, defaults to "variant" */
  prop?: TPropName | undefined;
  /** theme key for variant definitions */
  scale?: string;
  /** inline theme aware variants definitions  */
  variants?:
    | {
        [key in K]: TStyle;
      }
    | undefined;
}

export type Variant = <TStyle = object, K extends string = string, TPropName = string>(
  props: VariantArgs<TStyle, K, TPropName>,
) => (...args: any[]) => any;

export const variant: Variant = ({
  scale,
  prop = 'variant',
  // enables new api
  variants = {},
}) => {
  let sx;

  if (Object.keys(variants).length) {
    sx = (value, scale, props) => css(getValue(scale, value, null))(props.theme);
  } else {
    sx = (value, scale) => getValue(scale, value, null);
  }
  sx.scale = scale;
  sx.defaults = variants;
  const config = {
    [prop]: sx,
  };
  const parser = createParser(config);

  return parser;
};

export default variant;
